<ng-container *ngIf="viewModel$ | async as vm">
  <div *ngIf="vm.display" class="is-flex text-grey-70 is-family-medium text-12">
    <app-text>{{ 'station-app.__WIND_MAX_PERIOD' | AsyncLang | async }}</app-text>
    &nbsp;
    <app-text>{{ vm.maxWind | toUserUnit : EnumMeasureTypes.GUST_STRENGTH | toDisplayValue : EnumMeasureTypes.GUST_STRENGTH }}</app-text>
    &nbsp;
    <app-text unit [measureType]="EnumMeasureTypes.GUST_STRENGTH"></app-text>
  </div>
</ng-container>